// extracted by mini-css-extract-plugin
module.exports = {"root":"cmsBlock-root-h7i","content":"cmsBlock-content-SS-"};